import React from 'react';
import {
  AccountBalance, Celebration, ChildCare, CreditCard, DirectionsCar, Elderly, Event, Home, MoneyOff, Paid,
  PregnantWoman, School, ShowChart, Savings, TrendingUp, WarningAmber,
} from '@mui/icons-material';

/** Icon per timeline item `icon` key (from GET /timeline). */
export const TIMELINE_ICONS: Record<string, React.ReactElement> = {
  child: <ChildCare fontSize="small" />,
  leave: <PregnantWoman fontSize="small" />,
  home: <Home fontSize="small" />,
  paid: <Celebration fontSize="small" />,
  daycare: <ChildCare fontSize="small" />,
  school: <School fontSize="small" />,
  university: <School fontSize="small" />,
  invest: <ShowChart fontSize="small" />,
  retire: <Elderly fontSize="small" />,
  pension: <AccountBalance fontSize="small" />,
  credit: <CreditCard fontSize="small" />,
  warning: <WarningAmber fontSize="small" />,
  car: <DirectionsCar fontSize="small" />,
  money_in: <Savings fontSize="small" />,
  money_out: <MoneyOff fontSize="small" />,
  event: <Event fontSize="small" />,
  growth: <TrendingUp fontSize="small" />,
  cash: <Paid fontSize="small" />,
};

export const timelineIcon = (key: string) => TIMELINE_ICONS[key] ?? TIMELINE_ICONS.event;

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** "Jan 2027" (or "Jan 9, 2027" when withDay) from YYYY-MM-DD. */
export const timelineDate = (ymd: string, withDay = false) => {
  const [y, m, d] = ymd.slice(0, 10).split('-').map(Number);
  if (!m) return ymd;
  return withDay && d ? `${MONTHS[m - 1]} ${d}, ${y}` : `${MONTHS[m - 1]} ${y}`;
};

/** Upcoming (from asOf on) and past items, nearest first. */
export function splitTimeline<T extends { date: string; past: boolean }>(items: T[], upcoming: number, past: number) {
  const fut = items.filter((i) => !i.past).slice(0, upcoming);
  const pst = items.filter((i) => i.past).slice(-past).reverse();
  return { upcoming: fut, past: pst };
}
